import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api, nextDays, shortDate } from "@/lib/api";

export const SlotPicker = ({ practitionerId, serviceId, date, time, onChange }) => {
  const days = nextDays(21);
  const day = date || days[0];
  const [slots, setSlots] = useState(null);

  useEffect(() => {
    setSlots(null);
    api.get("/slots", { params: { practitioner_id: practitionerId, service_id: serviceId, date: day } })
      .then((r) => setSlots(r.data.slots)).catch(() => setSlots([]));
  }, [practitionerId, serviceId, day]);

  return (
    <div className="space-y-6">
      <div className="flex gap-2 overflow-x-auto pb-2" data-testid="date-strip">
        {days.map((d) => {
          const [wd, dn, mo] = shortDate(d).split(" ");
          return (
            <button key={d} type="button" onClick={() => onChange({ date: d, time: null })} data-testid={`date-button-${d}`}
              className={`shrink-0 w-16 rounded-2xl border py-3 text-center transition-colors ${d === day ? "bg-primary text-white border-primary" : "bg-card border-border hover:border-primary/40"}`}>
              <span className="block text-xs opacity-80">{wd}</span>
              <span className="block font-display font-bold text-lg">{dn}</span>
              <span className="block text-xs opacity-80">{mo}</span>
            </button>
          );
        })}
      </div>
      {slots === null ? (
        <Loader2 className="animate-spin text-primary" />
      ) : slots.length === 0 ? (
        <p className="text-muted-foreground" data-testid="no-slots-message">No open times on this day. Try another date.</p>
      ) : (
        <div className="grid grid-cols-3 sm:grid-cols-5 gap-2" data-testid="slot-grid">
          {slots.map((s) => (
            <button key={s} type="button" onClick={() => onChange({ date: day, time: s })} data-testid={`time-slot-button-${s}`}
              className={`rounded-xl border py-2.5 text-sm font-medium transition-colors ${s === time ? "bg-accent text-white border-accent" : "bg-card border-border hover:border-accent/60"}`}>
              {s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
